export const MODULE = "new/order-assign-user-via-context-menu";
